import { MuxScreen } from "./MuxScreen";

type Props = {
  id?: string;
  /** opacity-darken overlay strength (0..1) — higher = darker */
  darken?: number;
  /** show colored aurora overlay */
  aurora?: boolean;
};

/**
 * Full-bleed Mux video, faded into the page with a vertical gradient and
 * (optionally) a colored aurora wash on top so foreground text stays legible.
 */
export function MuxBackground({
  id = "C1lz00eqyA5d00yKspo32rHboDhjH2jEBAyO2lVT8uyKs",
  darken = 0.3,
  aurora = true,
}: Props) {
  return (
    <div
      aria-hidden
      style={{ position: "absolute", inset: 0, zIndex: 0, overflow: "hidden" }}
    >
      <MuxScreen
        id={id}
        className="absolute inset-0 w-full h-full"
        filter="saturate(1.1) contrast(1.05)"
      />

      <div
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background: `linear-gradient(180deg,
            rgba(4, 8, 11, ${Math.max(0, darken - 0.15)}) 0%,
            rgba(4, 8, 11, ${darken}) 45%,
            rgba(4, 8, 11, 0.95) 100%)`,
        }}
      />
      {aurora && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            mixBlendMode: "overlay",
            opacity: 0.7,
            background:
              "radial-gradient(60vmax 50vmax at 30% 30%, rgba(64,176,194,0.30), transparent 60%), radial-gradient(60vmax 50vmax at 80% 70%, rgba(61,220,151,0.18), transparent 60%)",
          }}
        />
      )}
    </div>
  );
}
